import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { dashboardAPI as apiConfig } from '../../../axiosConfig';

export const getChannelHashes = createAsyncThunk(
  'channelHash',
  // eslint-disable-next-line default-param-last
  async (fetchFromDB = false, { rejectWithValue }) => {
    try {
      const payload = fetchFromDB ? { params: { source: 'DB' } } : undefined;
      const { data } = await apiConfig.get('/channelhash', payload);
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const getChannelHashesById = createAsyncThunk(
  'channelHash/id',
  async ({ id }, { rejectWithValue }) => {
    try {
      const { data } = await apiConfig.get(`/channelhash/${id}`);
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const addChannelHashes = createAsyncThunk(
  'channelHash/add',
  async ({ payload, headers }, { rejectWithValue }) => {
    try {
      const { data } = await apiConfig.post('/channelhash', payload, {
        headers,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const updateChannelHashes = createAsyncThunk(
  'channelHash/update',
  async ({ payload, id, headers }, { rejectWithValue }) => {
    try {
      const { data } = await apiConfig.put(`/channelhash/${id}`, payload, {
        headers,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const deleteChannelHashes = createAsyncThunk(
  'channelHash/delete',
  async ({ id, headers }, { rejectWithValue }) => {
    try {
      const { data } = await apiConfig.delete(`/channelhash/${id}`, {
        headers,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const invalidateCache = createAsyncThunk(
  'channelHash/refreshCache',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await apiConfig.get('/channelhash/invalidatecache');
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

const channelHashSlice = createSlice({
  name: 'channelHash',
  initialState: {
    list: [],
  },
  reducers: {},
  extraReducers: {
    [getChannelHashes.fulfilled]: (state, action) => {
      state.list = [...action.payload];
    },
    [getChannelHashes.rejected]: (state) => {
      state.list = [];
    },
    [addChannelHashes.fulfilled]: (state, action) => {
      if (action.payload.status !== 'Created') {
        return;
      }

      const newToggle = action.payload.data;
      state.list.push(newToggle);
    },
    [updateChannelHashes.fulfilled]: (state, action) => {
      if (action.payload.status !== 'OK') {
        return;
      }

      const updatedId = action.payload.data && action.payload.data.id;
      const data = [...state.list];
      const updateIndex = data.findIndex(
        (channelHash) => channelHash.id === updatedId,
      );

      if (updateIndex !== -1) {
        data[updateIndex] = { ...action.payload.data };
        state.list = [...data];
      }
    },
    [deleteChannelHashes.fulfilled]: (state, action) => {
      if (action.payload.status !== 'OK') {
        return;
      }

      const data = [...state.list];
      const deletedId = action.payload.id;
      const deletedIndex = data.findIndex(
        (channelHash) => channelHash.id === deletedId,
      );
      data.splice(deletedIndex, 1);
      state.list = [...data];
    },
  },
});

export const channelHashActions = channelHashSlice.actions;

export default channelHashSlice.reducer;
